import { DURATION_SECONDS } from '../../constants';
import { Burst, BurstSlice } from '../../redux/features/burst/types';

export type FormattedMonth = {
  id: number;
  month: string;
  total: number;
  weeks: any[];
};

const formatData = (bursts: BurstSlice, months: string[]): FormattedMonth[] => {
  const data: FormattedMonth[] = [];

  Object.keys(bursts).forEach((burstType: string) => {
    if (burstType === 'columns') return;

    // Fetch all bursts
    const burstData = bursts[burstType as DURATION_SECONDS] as Burst;

    burstData.rows.forEach((row) => {
      // Get commencement data
      const weekCommencingDate = new Date(
        row.weekCommencing.split('-').reverse().join('-')
      );

      // Get month
      const month = months.find(
        (month) =>
          new Date(`${month} 1, 2000`).getMonth() ===
          weekCommencingDate.getMonth()
      );

      if (!month) {
        return;
      }

      let monthData = data.find((d) => d.month === month);

      if (!monthData) {
        monthData = { id: data.length + 1, month: month, weeks: [], total: 0 };
        data.push(monthData);
      }

      // match weekCommencing
      let weekData = monthData.weeks.find(
        (weekData) => weekData.weekCommencing === row.weekCommencing
      );

      if (!weekData) {
        weekData = {
          weekCommencing: row.weekCommencing,
          isSplit: row.weekMetaData.isSplit,
          numberOfDays: row.weekMetaData.numberOfDays,
          direction: row.weekMetaData.splitDirection
        };
        monthData.weeks.push(weekData);
      }

      if (!weekData[burstType]) {
        weekData[burstType] = [];
      }

      const newTotal = monthData.total + row.budget;
      monthData.total = Math.round(newTotal * 100) / 100;

      weekData[burstType].push({
        cpt: row.cpt,
        tarps: row.tarps,
        cost: row.budget
      });
    });
  });

  // ensure the data contains all specified months in order
  months.forEach((month) => {
    if (!data.find((monthData) => monthData.month === month)) {
      data.push({ id: data.length + 1, month: month, weeks: [], total: 0 });
    }
  });

  return data;
};

const marshalData = (
  burstSlice: BurstSlice,
  months: string[]
): FormattedMonth[] => {
  return formatData(burstSlice, months);
};

export default marshalData;
